module.exports = __webpack_public_path__ + "28b03bcc8534158827a417d932bebb30.svg";